import React, { PureComponent } from 'react';
import styled from 'styled-components';

import ShareBuybackImage from '../../../containers/assets/share-buyback.png';

const Wrapper = styled.div`
  background: #f5f6f7;
  flex: 1;
`;

const Container = styled.div`
  padding: 40px;
  width: 80%;
  max-width: 794px;
`;

const Text1 = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 16px;
  color: rgba(0, 27, 59, 0.38);
  text-transform: uppercase;
`;

const Text2 = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 700;
  font-size: 21px;
  line-height: 28px;
  color: rgba(0, 27, 59, 0.94);
  margin-top: 24px;
`;

const Text3 = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: rgba(0, 27, 59, 0.6);
  margin-top: 12px;

  a {
    color: #5c91f5;
  }

  b {
    font-weight: 700;
    color: rgba(0, 27, 59, 1);
  }
`;

const Image = styled.div`
  display: flex;
  margin-top: 12px;
`;

class ShareBuyback extends PureComponent {

  render() {
    return (
      <Wrapper>
        <Container>
          <Text1>What to expect</Text1>
          <Text2>Share Buyback</Text2>
          <Text3>
            <p>Your Head of Finance will be able to buyback ownership shares from investors. There are a variety of reasons why companies buyback shares. <a href="https://www.investopedia.com/articles/investing/112013/impact-share-repurchases.asp#:~:text=The buyback will simultaneously shrink,subsequent to a share buyback." target="_blank" rel="noreferrer">Reason 1</a>, <a href="https://hbr.org/2001/04/is-a-share-buyback-right-for-your-company" target="_blank" rel="noreferrer">Reason 2</a></p>
          </Text3>
          <Image>
            <img src={ShareBuybackImage} alt="" />
          </Image>
          <Text3>
            <p><b>Tip:</b> Buying back shares has an impact on your Balance Sheet’s Total Equity.</p>
          </Text3>
        </Container>
      </Wrapper>
    );
  }

}

export default ShareBuyback;



// WEBPACK FOOTER //
// ./src/components/onboarding/what-to-expect/ShareBuyback.js